import { render, staticRenderFns } from "./Defisc.vue?vue&type=template&id=2068745e&"
import script from "./Defisc.vue?vue&type=script&lang=js&"
export * from "./Defisc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports